// extracted by mini-css-extract-plugin
export default {"searched_blobb_div":"SearchedBlobb_searched_blobb_div__8EoVq","fade-in":"SearchedBlobb_fade-in__yd9on"};